// 무료 도구 머리 안쪽·본문·바닥 안내가 같이 쓰는 폭 — 로고·본문·안내의 왼쪽 가장자리를 맞춘다.
export const TOOLS_CONTAINER = "mx-auto w-full max-w-5xl px-4";
